import type { FC } from 'react';

import type { SearchItemEntity } from '@iconik-io/shared-lib/src/redux/entities/normalized/search_item';
import { isLiveAsset } from '@iconik-io/shared-lib/src/utils/is_live_asset';
import { Chip } from '@iconik-io/uad';

import TooltipTrigger from '../../tooltip_trigger/tooltip_trigger';

import styles from '../asset_status_icon_detailed.module.css';

const LiveStatus: FC<{ object: SearchItemEntity }> = ({ object }) => {
  if (object.type !== 'ASSET' || !isLiveAsset(object)) {
    return null;
  }

  return (
    <TooltipTrigger
      tooltipText="Live ingest in progress"
      placement="bottom"
      componentProps={{
        role: 'status',
        'aria-label': 'Live ingest in progress',
        className: styles.live,
      }}
    >
      <Chip color="red" size="s">
        LIVE
      </Chip>
    </TooltipTrigger>
  );
};

export default LiveStatus;
